import { Questionnaire } from "../models/questionnaire/questionnaire";
import { Team } from "../models/team/team";

export function getTeamQuestionnaireFromTeam(
  team: Team,
  questionnaireId: number,
) {
  return team.teamQuestionnaires?.find(
    (tq) => tq.questionnaireId === questionnaireId,
  );
}

export function getTeamQuestionnaireFromQuestionnaire(
  questionnaire: Questionnaire,
  teamId: number,
) {
  return questionnaire.teamQuestionnaires?.find((tq) => tq.teamId === teamId);
}
